import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './ExternalUsers.module.scss'

const RedirectExternalUsers = ({ seconds = 10, targetPage = '/' }) => {
  const [remaining, setRemaining] = useState(seconds)
  const history = useHistory()

  useEffect(() => {
    const timerId = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(timerId)
          window.localStorage.removeItem('externalUser')
          history.replace('/')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timerId)
  }, [history, targetPage])

  return (
    <>
      <div className={styles.label}>
        <span>
          This application can only be accessed by internal UHG or Optum users.
          As you are an external user you are being redirected to Home page in{' '}
          {remaining} second{remaining === 1 ? '' : 's'}
        </span>
      </div>
    </>
  )
}

export default RedirectExternalUsers
